import { createFileRoute } from "@tanstack/react-router";
import GeneratorBrowse from "@/pages/GeneratorBrowse";

export const Route = createFileRoute("/generators/type/$filterValue")({
  component: GeneratorBrowse,
});
